export default __webpack_public_path__ + "static/media/pic.7c01e2c8.svg";